"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Grid_1 = require("../../atoms/Grid");

var Headline_1 = require("../../atoms/Headline");

var Icon_1 = require("../../atoms/Icon");

var Paragraph_1 = require("../../atoms/Paragraph");

var IconLink_1 = require("../../molecules/IconLink");

var Stepper =
/** @class */
function (_super) {
  __extends(Stepper, _super);

  function Stepper() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Stepper.prototype.render = function () {
    var _a = this.props,
        title = _a.title,
        children = _a.children,
        links = _a.links;
    var numChildren = React.Children.count(children);
    var numColumns = Math.ceil(numChildren / 2) > Math.ceil(numChildren / 3) ? 3 : 2;
    return React.createElement("div", {
      className: "lsg--stepper"
    }, React.createElement(Headline_1.Headline, {
      size: Headline_1.Headline.Sizes.H2
    }, title), React.createElement(Grid_1.Grid, {
      verticalSpacing: Grid_1.Grid.Spacing.HALF_SECTION,
      marginTop: Grid_1.Grid.Spacing.HALF_SECTION,
      marginBottom: Grid_1.Grid.Spacing.HALF_SECTION
    }, React.createElement(Grid_1.Grid.Row, {
      asUl: true,
      gap: Grid_1.Grid.Spacing.CONTAINER
    }, React.Children.map(children, function (child) {
      return React.createElement(Grid_1.Grid.Column, {
        xs: 12,
        md: 12 / numColumns,
        asLi: true
      }, child);
    }))), React.createElement(IconLink_1.IconLinkGroup, {
      direction: IconLink_1.IconLinkGroup.Directions.HORIZONTAL
    }, links));
  };

  Stepper.Block = function (_a) {
    var iconName = _a.iconName,
        headline = _a.headline,
        text = _a.text;
    return React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "stepper-block"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "stepper-icon"
    }, React.createElement(Icon_1.Icon, {
      name: iconName,
      size: Icon_1.Icon.Sizes.CIRCLE2,
      color: Icon_1.Icon.Colors.PRIMARY
    })), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "stepper-text"
    }, React.createElement(Headline_1.Headline, {
      size: Headline_1.Headline.Sizes.H4
    }, headline), React.createElement(Paragraph_1.Paragraph, null, text)));
  };

  return Stepper;
}(React.Component);

exports.Stepper = Stepper;
Stepper.Block.displayName = "Stepper.Block";